import React, { useEffect } from 'react'
import Table from 'components/Table'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { isNotNilOrEmpty } from 'utils/ramda'
import { changeQuery, getCurrentParsedQuery } from 'utils/navigation'
import {
  selectCouriersList,
  selectCouriersListLoading,
  selectCouriersListPagination
} from 'modules/couriers/ducks/selectors'
import { fetchCouriersListRoutine } from 'modules/couriers/ducks/actions'
import { pathOr } from 'ramda'
import EditCourierModal from './EditCourierModal'
import { ActionsContainer } from 'theme/wrappers'

const defaultFilters = {
  page: 1,
  limit: 20,
  sort: 'name'
}

const CouriersTable = () => {
  const dispatch = useDispatch()
  const list = useSelector(selectCouriersList)
  const pagination = useSelector(selectCouriersListPagination)
  const isLoading = useSelector(selectCouriersListLoading)
  const {
    location: { search }
  } = useHistory()

  useEffect(() => {
    if (isNotNilOrEmpty(search)) {
      dispatch(fetchCouriersListRoutine({ query: search }))
    } else {
      changeQuery(defaultFilters)
    }
  }, [search])

  useEffect(() => {
    changeQuery(defaultFilters)
  }, [])

  const handlePageChange = (_, page) => {
    const parsedQuery = getCurrentParsedQuery()
    changeQuery({
      ...parsedQuery,
      page
    })
  }

  const headers = [
    { children: 'Nazwa kuriera', sort: 'name' },
    { children: 'Grupa', sort: 'groupName' },
    { children: '', align: 'right' }
  ]

  const rows = list.map(row => ({
    cells: [
      { children: row.name },
      { children: pathOr('---', ['group', 'name'], row) },
      {
        children: (
          <ActionsContainer>
            <EditCourierModal courier={row} />
          </ActionsContainer>
        ),
        align: 'right',
        preventRedirect: true
      }
    ]
  }))

  return (
    <Table
      pagination={pagination}
      onPageChange={handlePageChange}
      headers={headers}
      rows={rows}
      isLoading={isLoading}
    />
  )
}

export default CouriersTable
